import * as PopoverPrimitive from '@radix-ui/react-popover'
import { useIsScreenWidthBelow } from '@tebuto/functions/responsiveness'
import { cn } from '@tebuto/lib/utils'
import * as React from 'react'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

function getPortalContainer() {
    const widget = document.getElementById('tebuto-booking-widget')
    return widget?.querySelector('.widget-container') || widget || document.body
}

const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
        top?: number
        left?: number
    }
>(({ className, align = 'center', sideOffset = 4, top, left, style, children, ...props }, ref) => {
    const isAbsolute = typeof top === 'number' && typeof left === 'number'
    const isScreenBelowLg = useIsScreenWidthBelow(1024)

    return (
        <PopoverPrimitive.Portal container={getPortalContainer()}>
            {isScreenBelowLg ? (
                <div
                    ref={ref as React.RefObject<HTMLDivElement | null>}
                    style={Object.assign({}, style, {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        maxWidth: '100vw',
                        height: '100vh',
                        zIndex: 9999,
                        display: 'flex',
                        flexDirection: 'column'
                    })}
                    className={cn(
                        'rounded-none border-none p-0 w-screen max-w-[100vw] left-0 top-0 bg-popover text-popover-foreground shadow-md outline-none',
                        className
                    )}
                    {...props}
                >
                    {children}
                </div>
            ) : (
                <PopoverPrimitive.Content
                    ref={ref}
                    align={isAbsolute ? undefined : align}
                    side={isAbsolute ? undefined : props.side}
                    sideOffset={isAbsolute ? undefined : sideOffset}
                    style={isAbsolute ? Object.assign({}, style, { position: 'absolute', top, left }) : style}
                    className={cn(
                        'z-50 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none',
                        !isAbsolute && 'w-72',
                        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0',
                        'data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
                        'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2',
                        'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                        className
                    )}
                    {...props}
                >
                    {children}
                </PopoverPrimitive.Content>
            )}
        </PopoverPrimitive.Portal>
    )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
